import React, { useEffect } from 'react';
import { TopBar } from './components/TopBar';
import { OfferBar } from './components/OfferBar';
import { Hero } from './components/Hero';
import { VideoSection } from './components/VideoSection';
import { DesireSection } from './components/DesireSection';
import { BeginnersSection } from './components/BeginnersSection';
import { Gallery } from './components/Gallery';
import { IncludesSection } from './components/IncludesSection';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Testimonials } from './components/Testimonials';
import { PurchaseSection } from './components/PurchaseSection';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    document.title = 'El Arte de la Filigrana | Deco Emprende';

    // Meta Pixel Code
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '2083053129755433');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=2083053129755433&ev=PageView&noscript=1" />`;
    document.head.appendChild(noscript);
    return () => {
      document.head.removeChild(script);
      if (noscript.parentNode) document.head.removeChild(noscript);
    };
  }, []);
  return <div className="min-h-screen w-full bg-fil-bg font-sans selection:bg-fil-rose selection:text-white" data-id="element-0" data-mp="3688rpx40wyp">
      <TopBar data-id="element-1" data-mp="3udax89lkcp58" />
      <OfferBar data-id="element-2" data-mp="3ubrgkhvzwc2x" />
      <main data-id="element-3" data-mp="3uc9jtyh2rqkc">
        <Hero data-id="element-4" data-mp="3ucje3y95kjvu" />
        <VideoSection data-id="element-5" data-mp="3uf5hdlp0gd89" />
        <DesireSection data-id="element-6" data-mp="d4e9i476jx1z" />
        <BeginnersSection data-id="element-7" data-mp="d3mmvivk99nu" />
        <Gallery data-id="element-8" data-mp="d3wbp34vdary" />
        <IncludesSection data-id="element-9" data-mp="d2bgrcen7ptk" />
        <Bonuses data-id="element-10" data-mp="851l3f0nuhxa" />
        <HowItWorks data-id="element-11" data-mp="86meh1b8nutk" />
        <Testimonials data-id="element-12" data-mp="8648ve2os48z" />
        <PurchaseSection data-id="element-13" data-mp="83qgxe3az85n" />
        <FAQ data-id="element-14" data-mp="3gl4pnbwh7qhe" />
      </main>
      <Footer data-id="element-15" data-mp="3gmfvdh9hf8b5" />
      <SocialProofPopup data-id="element-16" data-mp="3glwbvw46obv0" />
    </div>;
}